// Lucide icon: rotate-cw (https://lucide.dev/icons/rotate-cw)
import { RotateCw } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconRotate = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <RotateCw />
    </IconComponentStyled>
  )
}
